(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1196],{

/***/ 32916:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel/review/[id]",
      function () {
        return __webpack_require__(38541);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(72276);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tabs/Tabs.js + 8 modules
var Tabs = __webpack_require__(11703);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(40044);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(21023);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(61715);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-swipeable-views/lib/index.js
var lib = __webpack_require__(77314);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
// EXTERNAL MODULE: ./utils/lazyRef.js
var lazyRef = __webpack_require__(81676);
// EXTERNAL MODULE: ./components/index.js + 25 modules
var components = __webpack_require__(60306);
// EXTERNAL MODULE: ./components/Map/Map.jsx
var Map = __webpack_require__(2699);
// EXTERNAL MODULE: ./components/HotelReview/HotelReview.module.scss
var HotelReview_module = __webpack_require__(15354);
var HotelReview_module_default = /*#__PURE__*/__webpack_require__.n(HotelReview_module);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var styles = __webpack_require__(16494);
// EXTERNAL MODULE: ./components/utils/replaceHTML.js
var replaceHTML = __webpack_require__(50549);
// EXTERNAL MODULE: ./components/Carousel/arrows/arrows.jsx
var arrows = __webpack_require__(9686);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Place.js
var Place = __webpack_require__(3769);
// EXTERNAL MODULE: ./components/HotelFilters/HotelsFilter/MobileFiltersHeader.jsx
var MobileFiltersHeader = __webpack_require__(77273);
;// CONCATENATED MODULE: ./components/HotelReview/HCHotelReview.jsx






































var SocialMediaLinks = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7401).then(__webpack_require__.bind(__webpack_require__, 17401));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17401)
            ];
        }
    }
});
var CallToSignUp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8307), __webpack_require__.e(8746)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    }
});
var HotelSearch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9989), __webpack_require__.e(2298), __webpack_require__.e(8423), __webpack_require__.e(7522), __webpack_require__.e(5494), __webpack_require__.e(7735)]).then(__webpack_require__.bind(__webpack_require__, 81666));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81666)
            ];
        }
    }
});
var RecommendationsList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9972).then(__webpack_require__.bind(__webpack_require__, 39972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39972)
            ];
        }
    }
});
var HotelOffers = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8838).then(__webpack_require__.bind(__webpack_require__, 18838));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18838)
            ];
        }
    }
});
var StyledTabs = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        variant: "scrollable",
        scrollButtons: "auto",
        TabIndicatorProps: {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "MuiTabs-indicatorSpan"
            })
        }
    }));
})({
    "& .MuiBox-root": {
        borderTop: "1px solid #86694B",
        borderBottom: "1px solid #86694B"
    },
    "& .MuiTabs-indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent"
    },
    "& .MuiTabs-indicatorSpan": {
        width: "100%",
        backgroundColor: "transparent"
    }
});
var StyledTab = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, (0,_object_spread/* default */.Z)({
        disableRipple: true
    }, props));
})(function(param) {
    var theme = param.theme;
    return {
        textTransform: "none",
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: "1.25rem",
        fontFamily: "PPFragment, serif",
        color: "#86694B",
        "&.Mui-selected": {
            color: "#202020"
        },
        "&.Mui-focusVisible": {
            backgroundColor: "transparent"
        },
        "&.MuiButtonBase-root": {
            padding: 16,
            height: 64,
            maxHeight: 64,
            minHeight: 64,
            fontSize: "1.25rem",
            fontFamily: "PPFragment, serif"
        }
    };
});
var tabsTheme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#202020"
        },
        secondary: {
            main: "#202020"
        }
    }
});
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = (0,_object_without_properties/* default */.Z)(props, [
        "children",
        "value",
        "index"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "tabpanel",
        hidden: value !== index,
        id: "simple-tabpanel-".concat(index),
        "aria-labelledby": "simple-tab-".concat(index)
    }, other), {
        children: value === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    }));
}
TabPanel.propTypes = {
    children: prop_types.node,
    index: prop_types.number.isRequired,
    value: prop_types.number.isRequired
};
function a11yProps(index) {
    return {
        id: "simple-tab-".concat(index),
        "aria-controls": "simple-tabpanel-".concat(index)
    };
}
var carouselRef = /*#__PURE__*/ (0,react.createRef)();
var responsive = {
    desktop: {
        breakpoint: {
            max: 99999,
            min: 1024
        },
        items: 3,
        slidesToSlide: 3
    },
    mobile: {
        breakpoint: {
            max: 1023,
            min: 0
        },
        items: 1,
        slidesToSlide: 1
    }
};
var getHotelReviewHCMetadata = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(hotel, currency) {
        var general, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/hotel/booking/".concat(hotel, "?currency=").concat(currency))
                    ];
                case 1:
                    general = _state.sent();
                    _tmp = {};
                    return [
                        4,
                        general.json()
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.general = _state.sent(), _tmp)
                    ];
            }
        });
    });
    return function getHotelReviewHCMetadata(hotel, currency) {
        return _ref.apply(this, arguments);
    };
}();
var getHotelReviewHCOffers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(hotel, query) {
        var general;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,httpClient/* httpPost */.Ko)("/api/hotel/booking/".concat(hotel), query)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    general = _state.sent();
                    return [
                        2,
                        {
                            general: general
                        }
                    ];
            }
        });
    });
    return function getHotelReviewHCOffers(hotel, query) {
        return _ref.apply(this, arguments);
    };
}();
var HCHotelReview = function(param) {
    var review = param.review, recommendation = param.recommendation, hotelId = param.hotelId, authCompleted = param.authCompleted;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73;
    var router = (0,next_router.useRouter)();
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var ref74 = (0,react.useState)(null), query = ref74[0], setQuery = ref74[1];
    var ref75 = (0,react.useState)(null), searchValue = ref75[0], setSearchValue = ref75[1];
    var ref76 = (0,react.useState)(false), loadingOffers = ref76[0], setLoadingOffers = ref76[1];
    var ref77 = (0,react.useState)(null), offersError = ref77[0], setOffersError = ref77[1];
    var ref78 = (0,react.useState)(null), analyticsData = ref78[0], setAnalyticsData = ref78[1];
    var ref79 = (0,react.useState)(true), searchToggled = ref79[0], toggleSearch = ref79[1];
    var ref80 = (0,lazyRef/* default */.Z)(), elementRef = ref80.elementRef, isSticky = ref80.isSticky;
    (0,react.useEffect)(function() {
        toggleSearch(true);
    }, [
        isSticky
    ]);
    var mapQuery = function(q) {
        var ref, ref1, ref2, ref3;
        return {
            destination: ((ref = q.autocomplete) === null || ref === void 0 ? void 0 : ref.k) || null,
            currency: userStore.currency,
            checkin: (ref1 = q.dateRange) === null || ref1 === void 0 ? void 0 : ref1.departure,
            checkout: (ref2 = q.dateRange) === null || ref2 === void 0 ? void 0 : ref2.return,
            rooms: (ref3 = q.visitors) === null || ref3 === void 0 ? void 0 : ref3.map(function(room) {
                var ref;
                return (0,_object_spread/* default */.Z)({
                    adult: +room.adults
                }, ((ref = room.childrenAges) === null || ref === void 0 ? void 0 : ref.length) && {
                    children: room.childrenAges.map(function(c) {
                        return +c;
                    })
                });
            })
        };
    };
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var ref81 = (0,react.useState)(1), tab = ref81[0], setTab = ref81[1];
    var ref82 = (0,react.useState)(0), nights = ref82[0], setNights = ref82[1];
    var ref83 = (0,react.useState)(null), hcMetadata = ref83[0], setHcMetadata = ref83[1];
    var ref84 = (0,react.useState)(null), hcOffers = ref84[0], setHcOffers = ref84[1];
    var ref85 = (0,react.useState)(false), isMobile = ref85[0], setIsMobile = ref85[1];
    var ref86 = (0,react.useState)(false), mobileSearch = ref86[0], setMobileSearch = ref86[1];
    var ref87 = (0,react.useState)(false), activityExpanded = ref87[0], setActivityExpanded = ref87[1];
    var ref88 = (0,react.useState)(false), generalExpanded = ref88[0], setGeneralExpanded = ref88[1];
    var ref89 = (0,react.useState)(false), servicesExpanded = ref89[0], setServicesExpanded = ref89[1];
    var ref90 = (0,react.useState)(73), stickySearchTop = ref90[0], setStickySearchTop = ref90[1];
    var getActivity = function() {
        var ref, ref1;
        return ((ref1 = (ref = hcMetadata === null || hcMetadata === void 0 ? void 0 : hcMetadata.general.HC) === null || ref === void 0 ? void 0 : ref.featureSummary.find(function(amenity) {
            return amenity.name === "Activities";
        })) === null || ref1 === void 0 ? void 0 : ref1.description.split(",")) || "";
    };
    var getGeneral = function() {
        var ref, ref1;
        return ((ref1 = (ref = hcMetadata === null || hcMetadata === void 0 ? void 0 : hcMetadata.general.HC) === null || ref === void 0 ? void 0 : ref.featureSummary.find(function(amenity) {
            return amenity.name === "Services";
        })) === null || ref1 === void 0 ? void 0 : ref1.description.split(",")) || "";
    };
    var getServices = function() {
        var ref, ref1;
        return ((ref1 = (ref = hcMetadata === null || hcMetadata === void 0 ? void 0 : hcMetadata.general.HC) === null || ref === void 0 ? void 0 : ref.featureSummary.find(function(amenity) {
            return amenity.name === "General";
        })) === null || ref1 === void 0 ? void 0 : ref1.description.split(",")) || "";
    };
    var executeScroll = function(ref) {
        var _$ref;
        var target = (0,_object_spread/* default */.Z)({}, ref);
        target === null || target === void 0 ? void 0 : (_$ref = target.current) === null || _$ref === void 0 ? void 0 : _$ref.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    var tabsRef = /*#__PURE__*/ (0,react.createRef)();
    (0,react.useEffect)(function() {
        setIsMobile(width <= 1024);
    }, [
        width
    ]);
    (0,react.useEffect)(function() {
        if (query) {
            setNights(moment_default()(query.checkout).diff(moment_default()(query.checkin), "days"));
            if ((query === null || query === void 0 ? void 0 : query.checkout) && (query === null || query === void 0 ? void 0 : query.checkin)) {
                executeScroll(tabsRef);
                setTab(0);
            }
        } else {
            setNights(0);
        }
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        if (userStore) {
            if (Object.keys(router.query).length) {
                setSearchValue(lib_default().parse(router.query));
                setQuery(mapQuery(lib_default().parse(router.query)));
            }
            var fetchMetadata = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getHotelReviewHCMetadata(hotelId, userStore.currency)
                                ];
                            case 1:
                                setHcMetadata.apply(void 0, [
                                    _state.sent()
                                ]);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchMetadata() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchMetadata();
        }
    }, [
        userStore,
        router
    ]);
    (0,react.useEffect)(function() {
        if (hcMetadata && (query === null || query === void 0 ? void 0 : query.checkin) && (query === null || query === void 0 ? void 0 : query.checkout) && !loadingOffers) {
            setLoadingOffers(true);
            var fetchOffers = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setAnalyticsData({
                                    hotelName: hcMetadata.general.HC.name,
                                    lengthOfStay: nights,
                                    searchId: hcMetadata.general.HC.id,
                                    destinationCountry: hcMetadata.general.HC.countryCode,
                                    destinationCity: hcMetadata.general.HC.place.fullName,
                                    numGuests: query.rooms.reduce(function() {
                                        var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, v = arguments.length > 1 ? arguments[1] : void 0;
                                        var ref;
                                        acc += ((ref = v.childrenAges) === null || ref === void 0 ? void 0 : ref.length) > 0 ? +v.adults + v.childrenAges.length : +v.adults;
                                        return acc;
                                    }, 0),
                                    numAdults: query.rooms.reduce(function() {
                                        var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, v = arguments.length > 1 ? arguments[1] : void 0;
                                        acc += +v.adult;
                                        return acc;
                                    }, 0),
                                    numChildren: query.rooms.reduce(function() {
                                        var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, v = arguments.length > 1 ? arguments[1] : void 0;
                                        var ref;
                                        acc += (ref = v.children) === null || ref === void 0 ? void 0 : ref.length;
                                        return acc;
                                    }, 0)
                                });
                                return [
                                    4,
                                    getHotelReviewHCOffers(hotelId, {
                                        checkin: query.checkin,
                                        checkout: query.checkout,
                                        currency: userStore.currency,
                                        country: userStore.country,
                                        rooms: query.rooms
                                    })
                                ];
                            case 1:
                                setHcOffers.apply(void 0, [
                                    _state.sent()
                                ]);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchOffers() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchOffers();
        }
    }, [
        hcMetadata
    ]);
    (0,react.useEffect)(function() {
        if (query && query.checkout && query.checkin) {
            var ref, ref1, ref2, ref3;
            if ((hcOffers === null || hcOffers === void 0 ? void 0 : (ref = hcOffers.general) === null || ref === void 0 ? void 0 : ref.HC) && !hcOffers.general.HC.isComplete) {
                setTimeout(function() {
                    var fetchOffers = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            getHotelReviewHCOffers(hotelId, {
                                                checkin: query.checkin,
                                                checkout: query.checkout,
                                                currency: userStore.currency,
                                                rooms: query.rooms
                                            })
                                        ];
                                    case 1:
                                        setHcOffers.apply(void 0, [
                                            _state.sent()
                                        ]);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function fetchOffers() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    fetchOffers();
                }, 1000);
            }
            if (hcOffers === null || hcOffers === void 0 ? void 0 : (ref1 = hcOffers.general) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.HC) === null || ref2 === void 0 ? void 0 : ref2.isComplete) {
                setLoadingOffers(false);
            }
            if (hcOffers === null || hcOffers === void 0 ? void 0 : (ref3 = hcOffers.general) === null || ref3 === void 0 ? void 0 : ref3.error) {
                setOffersError(hcOffers.general.error);
                setLoadingOffers(false);
            }
            setTab(0);
        }
    }, [
        hcOffers
    ]);
    var handleChange = function(event, newValue) {
        setTab(newValue);
    };
    var renderSearch = function(toggler, viewMode) {
        var preventCollapsing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
            triggerOnce: true,
            children: function(param) {
                var inView = param.inView, ref = param.ref;
                var ref1, ref2;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto",
                    ref: ref,
                    children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelSearch, {
                        value: searchValue,
                        viewMode: viewMode,
                        hotelName: hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref1 = hcMetadata.general) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.HC) === null || ref2 === void 0 ? void 0 : ref2.name,
                        hotelId: hotelId,
                        toggleSearch: toggler,
                        collapsed: !preventCollapsing && isSticky
                    })
                });
            }
        });
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Review of ",
                            ((ref = review.bc) === null || ref === void 0 ? void 0 : ref.name) ? review.bc.name : (ref1 = review.hc) === null || ref1 === void 0 ? void 0 : ref1.name,
                            " - First-Class.com"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat("https://www.first-class.com", "/hotel/review/").concat(review.safename ? review.safename : router.query.id)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: (0,replaceHTML/* replaceHTML */.m)((ref2 = review.bcom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hotel_data) === null || ref3 === void 0 ? void 0 : ref3.hotel_description)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "first-class.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Review of ".concat(((ref4 = review.bc) === null || ref4 === void 0 ? void 0 : ref4.name) ? review.bc.name : (ref5 = review.hc) === null || ref5 === void 0 ? void 0 : ref5.name, " ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: (0,replaceHTML/* replaceHTML */.m)((ref6 = review.bcom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.hotel_data) === null || ref7 === void 0 ? void 0 : ref7.hotel_description)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: (ref9 = (ref8 = review.hc) === null || ref8 === void 0 ? void 0 : ref8.images[0]) === null || ref9 === void 0 ? void 0 : ref9.large
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Review of ".concat(((ref10 = review.bc) === null || ref10 === void 0 ? void 0 : ref10.name) ? review.bc.name : (ref11 = review.hc) === null || ref11 === void 0 ? void 0 : ref11.name, " ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: (ref13 = (ref12 = review.hc) === null || ref12 === void 0 ? void 0 : ref12.images[0]) === null || ref13 === void 0 ? void 0 : ref13.large
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: (0,replaceHTML/* replaceHTML */.m)((ref14 = review.bcom) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.hotel_data) === null || ref15 === void 0 ? void 0 : ref15.hotel_description)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((HotelReview_module_default()).hotelReviewWrapper, "bg-review-bg relative"),
                children: [
                    review.bookingAvailable && !isMobile && isSticky && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, (HotelReview_module_default()).stickySearch, isSticky), (0,_define_property/* default */.Z)(_obj, "hidden", !searchToggled), _obj)),
                        style: {
                            top: stickySearchTop
                        },
                        ref: elementRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                width: "300px",
                                background: "white",
                                padding: "8px"
                            },
                            children: renderSearch(toggleSearch, "sideSearch")
                        })
                    }),
                    review.bookingAvailable && isMobile && isSticky && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((0,_define_property/* default */.Z)({}, (HotelReview_module_default()).stickyMobileSearch, isSticky)),
                        style: {
                            top: stickySearchTop
                        },
                        ref: elementRef,
                        children: [
                            mobileSearch && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    background: "white",
                                    padding: "1rem",
                                    display: "flex",
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        color: "inherit",
                                        onClick: function() {
                                            return setMobileSearch(false);
                                        },
                                        "aria-label": "close",
                                        className: (HotelReview_module_default()).closeMobileSearch,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelSearch, {
                                        value: searchValue,
                                        viewMode: "sideSearch",
                                        hotelName: hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref16 = hcMetadata.general) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.HC) === null || ref17 === void 0 ? void 0 : ref17.name,
                                        hotelId: hotelId
                                    })
                                ]
                            }),
                            !mobileSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFiltersHeader/* default */.Z, {
                                setSearchCollapsed: mobileSearch,
                                action: function() {
                                    return setMobileSearch(true);
                                },
                                onPinToTop: function(value) {
                                    return setStickySearchTop(value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HotelReview_module_default()).topSectionCarousel,
                        style: {
                            height: ((ref18 = carouselRef.current) === null || ref18 === void 0 ? void 0 : ref18.clientWidth) / 1.777 || 200
                        },
                        children: !!((ref19 = review.hc) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.images) === null || ref20 === void 0 ? void 0 : ref20.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                            responsive: responsive,
                            infinite: true,
                            customLeftArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows/* CustomLeftArrow */.q, {}),
                            customRightArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows/* CustomRightArrow */.i, {}),
                            containerClass: (HotelReview_module_default()).carouselContainer,
                            children: review.hc.images.map(function(img, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    ref: carouselRef,
                                    className: classnames_default()("relative w-full h-full", (0,_define_property/* default */.Z)({}, "px-2", !isMobile && (index === 1 || index % 3 === 1))),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "h-full w-full",
                                        src: img === null || img === void 0 ? void 0 : img.large
                                    })
                                }, img === null || img === void 0 ? void 0 : img.large);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container sm:px-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BCBreadcrumbs */.k7, {
                                headerText: review.name || ((ref21 = review.hc) === null || ref21 === void 0 ? void 0 : ref21.name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((HotelReview_module_default()).headerTop, "font-fragment"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    enterTouchDelay: 1,
                                    enterDelay: 0,
                                    leaveTouchDelay: 10000,
                                    title: "This star rating is provided to First-Class.com by our hotel partners, and its usually determined by an official hotel rating organisation or another third party.",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "mb-3 lg:text-5xl sm:text-3xl font-fragment flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: classnames_default()((HotelReview_module_default())["hotelName".concat(hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref22 = hcMetadata.general) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.HC) === null || ref23 === void 0 ? void 0 : ref23.starRating)]),
                                            children: ((ref24 = review.bc) === null || ref24 === void 0 ? void 0 : ref24.name) ? review.bc.name : (ref25 = review.hc) === null || ref25 === void 0 ? void 0 : ref25.name
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((HotelReview_module_default()).aboutSectionWrapper),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((HotelReview_module_default()).aboutSectionContentWrapper),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((HotelReview_module_default()).aboutSectionContent, "flex lg:flex-col flex-wrap lg:flex-nowrap col-span-4 sm:col-span-12"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((HotelReview_module_default()).aboutSectionScores),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "grid grid-cols-12 gap-x-5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-span-9 sm:col-span-12",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "w-full grid grid-cols-12 gap-x-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: classnames_default()((HotelReview_module_default()).aboutSectionContent, "flex lg:flex-col flex-wrap lg:flex-nowrap col-span-4 sm:col-span-12"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: classnames_default()((HotelReview_module_default()).aboutSectionHeading, "flex flex-col w-full"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: classnames_default()((HotelReview_module_default()).aboutSectionAddress),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Place/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                children: ((ref26 = review.bc) === null || ref26 === void 0 ? void 0 : ref26.address) || ((ref27 = review.hc) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.place) === null || ref28 === void 0 ? void 0 : ref28.fullName) || ((ref29 = review.hc) === null || ref29 === void 0 ? void 0 : ref29.address)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                children: [
                                                                                                    (ref30 = review.bc) === null || ref30 === void 0 ? void 0 : ref30.zip,
                                                                                                    " ",
                                                                                                    ((ref31 = review.bc) === null || ref31 === void 0 ? void 0 : ref31.zip) && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                                                    " ",
                                                                                                    (ref32 = review.bc) === null || ref32 === void 0 ? void 0 : ref32.country
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: classnames_default()((HotelReview_module_default()).aboutSectionUserScore),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "mt-4",
                                                                                        children: !!((ref33 = review.hc) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.reviews) === null || ref34 === void 0 ? void 0 : ref34.numberOfReviews) && Object.keys((ref35 = review.hc) === null || ref35 === void 0 ? void 0 : ref35.reviews.guestRatings).map(function(key) {
                                                                                            var ref;
                                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                                                                className: "mb-2 w-full",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ProgressMeter */.AP, {
                                                                                                    label: key,
                                                                                                    progress: ((ref = review.hc) === null || ref === void 0 ? void 0 : ref.reviews.guestRatings[key]) * 10
                                                                                                })
                                                                                            }, key);
                                                                                        })
                                                                                    }),
                                                                                    !!(hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref36 = hcMetadata.general) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.HC) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.reviews) === null || ref38 === void 0 ? void 0 : ref38.numberOfReviews) && !!((ref39 = review.hc) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.reviews) === null || ref40 === void 0 ? void 0 : ref40.guestRatings) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "xs:mb-2",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CircleRating */.Vp, {
                                                                                            rating: Math.round(hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref41 = hcMetadata.general) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.HC) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.reviews) === null || ref43 === void 0 ? void 0 : ref43.guestRatings["OVERALL"]),
                                                                                            text: "".concat((ref44 = hcMetadata.general.HC) === null || ref44 === void 0 ? void 0 : ref44.reviews.numberOfReviews, " user ratings.<br/>Rating - ").concat(hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref45 = hcMetadata.general) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.HC) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.reviews) === null || ref47 === void 0 ? void 0 : ref47.guestRatings["OVERALL"])
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: classnames_default()((HotelReview_module_default()).aboutSectionContent, "col-span-8 sm:col-span-12 sm:mt-5"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: classnames_default()((HotelReview_module_default()).aboutSectionText),
                                                                        children: [
                                                                            ((ref48 = review.bcom) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.hotel_data) === null || ref49 === void 0 ? void 0 : ref49.hotel_description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: classnames_default()((HotelReview_module_default()).reviewAmenitiesHeading, "font-libre"),
                                                                                        children: "About"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: classnames_default()("font-libre"),
                                                                                        children: (ref50 = review.bcom) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.hotel_data) === null || ref51 === void 0 ? void 0 : ref51.hotel_description
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "flex justify-between",
                                                                                children: [
                                                                                    getGeneral() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "flex flex-col w-1/2",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: classnames_default()((HotelReview_module_default()).reviewAmenitiesHeading, "font-libre mt-4"),
                                                                                                children: "General"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: classnames_default()("font-libre"),
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                                        className: (HotelReview_module_default()).amenityList,
                                                                                                        children: [
                                                                                                            !generalExpanded && getGeneral().splice(0, 5).map(function(amenity) {
                                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                                    className: (HotelReview_module_default()).amenityListItem,
                                                                                                                    children: amenity
                                                                                                                }, amenity);
                                                                                                            }),
                                                                                                            generalExpanded && getGeneral().map(function(amenity) {
                                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                                    className: (HotelReview_module_default()).amenityListItem,
                                                                                                                    children: amenity
                                                                                                                }, amenity);
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    !generalExpanded && getGeneral().length > 5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                        className: (HotelReview_module_default()).expandAmenity,
                                                                                                        onClick: function() {
                                                                                                            return setGeneralExpanded(true);
                                                                                                        },
                                                                                                        children: [
                                                                                                            "+ Show ",
                                                                                                            getGeneral().length - 5,
                                                                                                            " more"
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "flex flex-col w-1/2",
                                                                                        children: [
                                                                                            getActivity() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "flex flex-col",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: classnames_default()((HotelReview_module_default()).reviewAmenitiesHeading, "font-libre mt-4"),
                                                                                                        children: "Activities"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: classnames_default()("font-libre"),
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                                                className: (HotelReview_module_default()).amenityList,
                                                                                                                children: [
                                                                                                                    !activityExpanded && getActivity().splice(0, 3).map(function(amenity) {
                                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                                            className: (HotelReview_module_default()).amenityListItem,
                                                                                                                            children: amenity
                                                                                                                        }, amenity);
                                                                                                                    }),
                                                                                                                    activityExpanded && getActivity().map(function(amenity) {
                                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                                            className: (HotelReview_module_default()).amenityListItem,
                                                                                                                            children: amenity
                                                                                                                        }, amenity);
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            !activityExpanded && getActivity().length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                                className: (HotelReview_module_default()).expandAmenity,
                                                                                                                onClick: function() {
                                                                                                                    return setActivityExpanded(true);
                                                                                                                },
                                                                                                                children: [
                                                                                                                    "+ Show ",
                                                                                                                    getActivity().length - 3,
                                                                                                                    " ",
                                                                                                                    "more"
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            getServices() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "flex flex-col",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: classnames_default()((HotelReview_module_default()).reviewAmenitiesHeading, "font-libre mt-4"),
                                                                                                        children: "Services"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: classnames_default()("font-libre"),
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                                                className: (HotelReview_module_default()).amenityList,
                                                                                                                children: [
                                                                                                                    !servicesExpanded && getServices().splice(0, 3).map(function(amenity) {
                                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                                            className: (HotelReview_module_default()).amenityListItem,
                                                                                                                            children: amenity
                                                                                                                        }, amenity);
                                                                                                                    }),
                                                                                                                    servicesExpanded && getServices().map(function(amenity) {
                                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                                            className: (HotelReview_module_default()).amenityListItem,
                                                                                                                            children: amenity
                                                                                                                        }, amenity);
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            !servicesExpanded && getServices().length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                                className: (HotelReview_module_default()).expandAmenity,
                                                                                                                onClick: function() {
                                                                                                                    return setServicesExpanded(true);
                                                                                                                },
                                                                                                                children: [
                                                                                                                    "+ Show ",
                                                                                                                    getServices().length - 3,
                                                                                                                    " ",
                                                                                                                    "more"
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-span-3 sm:col-span-12 flex flex-col items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classnames_default()((HotelReview_module_default()).aboutSectionUserScoreMobile),
                                                                children: !!(hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref52 = hcMetadata.general) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.HC) === null || ref53 === void 0 ? void 0 : (ref54 = ref53.reviews) === null || ref54 === void 0 ? void 0 : ref54.numberOfReviews) && !!((ref55 = review.hc) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.reviews) === null || ref56 === void 0 ? void 0 : ref56.guestRatings) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "xs:mb-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CircleRating */.Vp, {
                                                                        rating: Math.round(hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref57 = hcMetadata.general) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.HC) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.reviews) === null || ref59 === void 0 ? void 0 : ref59.guestRatings["OVERALL"]),
                                                                        text: "".concat((ref60 = hcMetadata.general.HC) === null || ref60 === void 0 ? void 0 : ref60.reviews.numberOfReviews, " user ratings.<br/>Rating - ").concat(hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref61 = hcMetadata.general) === null || ref61 === void 0 ? void 0 : (ref62 = ref61.HC) === null || ref62 === void 0 ? void 0 : (ref63 = ref62.reviews) === null || ref63 === void 0 ? void 0 : ref63.guestRatings["OVERALL"])
                                                                    })
                                                                })
                                                            }),
                                                            review.bookingAvailable && !isSticky && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classnames_default()((HotelReview_module_default()).aboutSectionSearch),
                                                                ref: elementRef,
                                                                children: [
                                                                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                        sx: {
                                                                            background: "white",
                                                                            padding: "0.5rem 0.5rem",
                                                                            marginLeft: "auto",
                                                                            marginRight: "auto"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelSearch, {
                                                                            value: searchValue,
                                                                            viewMode: "sideSearch",
                                                                            hotelName: hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref64 = hcMetadata.general) === null || ref64 === void 0 ? void 0 : (ref65 = ref64.HC) === null || ref65 === void 0 ? void 0 : ref65.name,
                                                                            hotelId: hotelId
                                                                        })
                                                                    }),
                                                                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (HotelReview_module_default()).priceContainer,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (HotelReview_module_default()).priceContainerMoreReviews,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VintageButton */.Fz, {
                                                                                href: "/hotels/reviews",
                                                                                className: classnames_default()((HotelReview_module_default()).moreReviewsButton, "relative"),
                                                                                target: "_blank",
                                                                                label: "More hotel reviews",
                                                                                dark: true
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
                                theme: tabsTheme,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            borderBottom: 1,
                                            borderTop: 1,
                                            borderColor: "#86694B",
                                            marginTop: "2rem",
                                            scrollMarginTop: "80px"
                                        },
                                        ref: tabsRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabs, {
                                            value: tab,
                                            onChange: handleChange,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, (0,_object_spread/* default */.Z)({
                                                    label: "Offers"
                                                }, a11yProps(0))),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, (0,_object_spread/* default */.Z)({
                                                    label: "Map"
                                                }, a11yProps(1))),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, (0,_object_spread/* default */.Z)({
                                                    label: "Amenities"
                                                }, a11yProps(2)))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
                                        axis: "x",
                                        index: tab,
                                        onChangeIndex: setTab,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                                                value: tab,
                                                index: 0,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (HotelReview_module_default()).offersContainer,
                                                    children: [
                                                        loadingOffers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (HotelReview_module_default()).loader
                                                        }),
                                                        !loadingOffers && !offersError && /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelOffers, {
                                                            analyticsData: analyticsData,
                                                            offers: hcOffers === null || hcOffers === void 0 ? void 0 : (ref66 = hcOffers.general) === null || ref66 === void 0 ? void 0 : (ref67 = ref66.HC) === null || ref67 === void 0 ? void 0 : ref67.results,
                                                            suppliers: hcOffers === null || hcOffers === void 0 ? void 0 : (ref68 = hcOffers.general) === null || ref68 === void 0 ? void 0 : (ref69 = ref68.HC) === null || ref69 === void 0 ? void 0 : ref69.providers,
                                                            nights: nights
                                                        }),
                                                        !loadingOffers && offersError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "font-fragment text-center mt-4 text-2xl",
                                                            children: "Something went wrong during fetching offers, please try again or later."
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                                                value: tab,
                                                index: 1,
                                                children: (hcMetadata === null || hcMetadata === void 0 ? void 0 : hcMetadata.general) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        width: "100%",
                                                        padding: [
                                                            "1rem 0",
                                                            "1rem 0",
                                                            "1rem 0"
                                                        ],
                                                        height: "calc(600px + 2rem)"
                                                    },
                                                    children: hcMetadata && /*#__PURE__*/ (0,jsx_runtime.jsx)(Map/* default */.Z, {
                                                        center: {
                                                            lat: (ref70 = review.hc) === null || ref70 === void 0 ? void 0 : ref70.latitude,
                                                            lng: (ref71 = review.hc) === null || ref71 === void 0 ? void 0 : ref71.longitude
                                                        },
                                                        containerStyle: {
                                                            width: "100%",
                                                            height: "600px"
                                                        },
                                                        metaInfo: {
                                                            name: (ref72 = review.hc) === null || ref72 === void 0 ? void 0 : ref72.name
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                                                value: tab,
                                                index: 2,
                                                children: (hcMetadata === null || hcMetadata === void 0 ? void 0 : hcMetadata.general) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()((HotelReview_module_default()).amenitiesContainer, "font-libre"),
                                                    children: (ref73 = hcMetadata.general.HC) === null || ref73 === void 0 ? void 0 : ref73.featureSummary.map(function(amenity) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (HotelReview_module_default()).amenity,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (HotelReview_module_default()).amenityName,
                                                                    children: amenity.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: amenity.content,
                                                                    children: amenity.description.split(",").map(function(val) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (HotelReview_module_default()).amenityContentItem,
                                                                            children: val
                                                                        }, val);
                                                                    })
                                                                })
                                                            ]
                                                        }, amenity.name);
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                                        triggerOnce: true,
                                        children: function(param) {
                                            var inView = param.inView, ref = param.ref;
                                            var ref1, ref2;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                ref: ref,
                                                className: "w-full mx-auto mb-8",
                                                children: inView && review.bookingAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "container flex flex-col mt-8",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "sm:hidden mb-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            sx: {
                                                                width: "100%",
                                                                background: "white",
                                                                padding: [
                                                                    "1rem 0",
                                                                    "1rem 2rem",
                                                                    "1rem 2rem"
                                                                ],
                                                                marginLeft: "auto",
                                                                marginRight: "auto"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: classnames_default()((HotelReview_module_default()).searchHeading, "font-fragment"),
                                                                    children: "Find best hotel offers"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelSearch, {
                                                                    viewMode: "mainSearch",
                                                                    hotelName: hcMetadata === null || hcMetadata === void 0 ? void 0 : (ref1 = hcMetadata.general) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.HC) === null || ref2 === void 0 ? void 0 : ref2.name,
                                                                    value: searchValue
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                                        triggerOnce: true,
                                        children: function(param) {
                                            var inView = param.inView, ref = param.ref;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                ref: ref,
                                                className: "w-full mx-auto mb-8",
                                                children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLinks, {})
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "container flex justify-center items-center mt-20 mx-auto w-48",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VintageButton */.Fz, {
                                            href: "/hotels/reviews",
                                            className: classnames_default()((HotelReview_module_default()).moreReviewsButton, "relative"),
                                            target: "_blank",
                                            label: "More hotel reviews",
                                            dark: true
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                        triggerOnce: true,
                        children: function(param) {
                            var inView = param.inView, ref = param.ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                ref: ref,
                                className: "w-full mx-auto my-20 sm:mb-10",
                                children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToSignUp, {
                                        country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                                        authCompleted: authCompleted,
                                        sourcePage: "HCHotelReview"
                                    })
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                        triggerOnce: true,
                        children: function(param) {
                            var inView = param.inView, ref = param.ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: ref,
                                className: "w-full mx-auto my-8 px-4 lg:px-0",
                                children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationsList, {
                                        items: recommendation
                                    })
                                })
                            });
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/HotelReview/HotelReview.jsx
var HotelReview = __webpack_require__(38116);
// EXTERNAL MODULE: ./Layout/Layout.jsx + 7 modules
var Layout = __webpack_require__(24987);
// EXTERNAL MODULE: ./components/HotelReview/MiniHotelReview.jsx
var MiniHotelReview = __webpack_require__(39848);
;// CONCATENATED MODULE: ./pages/hotel/review/[id].jsx





function HotelReviewHO(param) {
    var review = param.review, recommendation = param.recommendation, hotelId = param.hotelId;
    switch(review.type){
        case "HOTELREVIEW":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelReview/* HotelReview */.P, {
                review: review,
                recommendation: recommendation,
                hotelId: hotelId
            });
        case "EXTERNAL":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HCHotelReview, {
                review: review,
                recommendation: recommendation,
                hotelId: hotelId
            });
        case "HOTELSHORTREVIEW":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniHotelReview/* MiniHotelReview */.M, {
                review: review,
                recommendation: recommendation,
                hotelId: hotelId
            });
    }
}
var __N_SSP = true;
/* harmony default export */ var _id_ = ((0,Layout/* withLayout */.X)(HotelReviewHO, true));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,1255,4231,129,1979,7601,9125,2769,9410,6700,632,9780,6420,4987,2952,9774,2888,179], function() { return __webpack_exec__(32916); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);